import { VALUE_UPDATE_EVENT } from "../../lib/constants.js";
import { computed, createBlock, createElementVNode, openBlock, renderSlot, unref, withCtx } from "vue";
import { DtInput, VALIDATION_MESSAGE_TYPES } from "@dialpad/dialtone-vue";
//#region src/components/controls/control_string.vue
var _hoisted_1 = { class: "d-input__label-text d-label--sm" };
var _sfc_main = /* @__PURE__ */ Object.assign({ name: "DtcControlString" }, {
	props: {
		value: {
			type: String,
			default: () => String()
		},
		disabled: {
			type: Boolean,
			default: false
		},
		warning: {
			type: String,
			default: void 0
		}
	},
	emits: [VALUE_UPDATE_EVENT],
	setup(__props, { emit: __emit }) {
		const props = __props;
		const emit = __emit;
		const messages = computed(() => {
			const messages = [];
			if (props.warning) messages.push({
				message: props.warning,
				type: VALIDATION_MESSAGE_TYPES.WARNING
			});
			return messages;
		});
		return (_ctx, _cache) => {
			return openBlock(), createBlock(unref(DtInput), {
				value: __props.value,
				disabled: __props.disabled,
				messages: messages.value,
				size: "sm",
				onInput: _cache[0] || (_cache[0] = (e) => emit(unref("update:value"), e))
			}, {
				labelSlot: withCtx(() => [createElementVNode("span", _hoisted_1, [renderSlot(_ctx.$slots, "default")])]),
				rightIcon: withCtx(() => [renderSlot(_ctx.$slots, "icon")]),
				_: 3
			}, 8, [
				"value",
				"disabled",
				"messages"
			]);
		};
	}
});
//#endregion
export { _sfc_main as default };

//# sourceMappingURL=control_string.vue.js.map